import { render, staticRenderFns } from "./follow-record.vue?vue&type=template&id=69325c56&scoped=true"
import script from "./follow-record.vue?vue&type=script&lang=js"
export * from "./follow-record.vue?vue&type=script&lang=js"
import style0 from "./follow-record.vue?vue&type=style&index=0&id=69325c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69325c56",
  null
  
)

export default component.exports